import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Button from "antd/es/button/index.js";
import selectNext from '@data-driven-forms/common/wizard/select-next';

var NextButton = function NextButton(_ref) {
  var nextStep = _ref.nextStep,
      handleNext = _ref.handleNext,
      handleSubmit = _ref.handleSubmit,
      buttonLabels = _ref.buttonLabels,
      getState = _ref.getState,
      valid = _ref.valid,
      NextButtonProps = _ref.NextButtonProps,
      SubmitButtonProps = _ref.SubmitButtonProps,
      conditionalSubmitFlag = _ref.conditionalSubmitFlag;
  var nextResult = nextStep ? selectNext(nextStep, getState) : nextStep;
  var progressNext = nextResult !== conditionalSubmitFlag && nextStep;
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "primary",
    htmlType: "button",
    onClick: function onClick() {
      return progressNext ? handleNext(nextResult) : handleSubmit();
    },
    disabled: !valid
  }, progressNext ? NextButtonProps : SubmitButtonProps), progressNext ? buttonLabels.next : buttonLabels.submit);
};

NextButton.propTypes = {
  nextStep: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool,
  handleNext: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired,
  buttonLabels: PropTypes.shape({
    submit: PropTypes.node.isRequired,
    cancel: PropTypes.node.isRequired,
    back: PropTypes.node.isRequired,
    next: PropTypes.node.isRequired
  }).isRequired,
  NextButtonProps: PropTypes.object,
  SubmitButtonProps: PropTypes.object,
  conditionalSubmitFlag: PropTypes.string.isRequired
};

var WizardStepButtons = function WizardStepButtons(_ref2) {
  var disableBack = _ref2.disableBack,
      handlePrev = _ref2.handlePrev,
      nextStep = _ref2.nextStep,
      formOptions = _ref2.formOptions,
      handleNext = _ref2.handleNext,
      buttonLabels = _ref2.buttonLabels,
      ButtonProps = _ref2.ButtonProps,
      NextButtonProps = _ref2.NextButtonProps,
      CancelButtonProps = _ref2.CancelButtonProps,
      BackButtonProps = _ref2.BackButtonProps,
      SubmitButtonProps = _ref2.SubmitButtonProps,
      conditionalSubmitFlag = _ref2.conditionalSubmitFlag;
  return /*#__PURE__*/React.createElement("div", ButtonProps, formOptions.onCancel && /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    variant: "contained",
    color: "secondary",
    onClick: formOptions.onCancel
  }, CancelButtonProps), buttonLabels.cancel), /*#__PURE__*/React.createElement(Button, _extends({
    htmlType: "button",
    disabled: disableBack,
    onClick: handlePrev
  }, BackButtonProps), buttonLabels.back), /*#__PURE__*/React.createElement(NextButton, _extends({}, formOptions, {
    handleNext: handleNext,
    nextStep: nextStep,
    buttonLabels: buttonLabels,
    NextButtonProps: NextButtonProps,
    SubmitButtonProps: SubmitButtonProps,
    conditionalSubmitFlag: conditionalSubmitFlag
  })));
};

WizardStepButtons.propTypes = {
  disableBack: PropTypes.bool,
  handlePrev: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  conditionalSubmitFlag: PropTypes.string.isRequired,
  nextStep: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    when: PropTypes.string.isRequired,
    stepMapper: PropTypes.object.isRequired
  })]),
  buttonLabels: PropTypes.object.isRequired,
  formOptions: PropTypes.shape({
    onCancel: PropTypes.func.isRequired
  }).isRequired,
  ButtonProps: PropTypes.object,
  NextButtonProps: PropTypes.object,
  BackButtonProps: PropTypes.object,
  CancelButtonProps: PropTypes.object,
  SubmitButtonProps: PropTypes.object
};
export default WizardStepButtons;